import { Notification, NotificationInterface, NotificationTemplateInterface } from '../models';

import { NotificationActions, NotificationActionType } from './actions';
import { NotificationState, NotificationStateInterface } from './notification-state.model';

const initialState: NotificationState = new NotificationState({
  ids: [],
  notifications: {},
  selectedNotification: 0,
  notificationTemplates: [],
  sendResults: 0,
});

export function notificationReducer(state: NotificationStateInterface = initialState,
                                    action: NotificationActions): NotificationStateInterface {
  switch(action.type) {

    // clear the state if loading or there is a failure
    case NotificationActionType.LoadNotifications:
    case NotificationActionType.LoadNotificationsFailed:
      return {
        ...state,
        ids: [],
        notifications: {},
      };

    // Update state with notification response
    case NotificationActionType.LoadNotificationsCompleted:
      const resultNotifications: NotificationInterface[] = action.payload as NotificationInterface[];

      const notificationIds: number[] = resultNotifications.map((notification: NotificationInterface) => notification.id);

      const resultNotificationEntities: { [id: number]: NotificationInterface } = resultNotifications.reduce(
        (notifications: { [id: number]: NotificationInterface }, notification: NotificationInterface) => {
          return {...notifications, ...{
            [notification.id]: new Notification(notification),
          }};
        },
        {});

      return {
        ...state,
        ids: notificationIds,
        notifications: resultNotificationEntities,
      };

    case NotificationActionType.UpdateNotificationCompleted:
      const updatedNotification: NotificationInterface = action.payload as NotificationInterface;
      const updatedNotifications: { [id: number]: NotificationInterface } = { ...state.notifications };

      if(updatedNotification) {
        updatedNotifications[updatedNotification.id] = new Notification(updatedNotification);
      }

      return {
        ...state,
        notifications: updatedNotifications,
      };

    case NotificationActionType.UpdateNotificationsReadStateCompleted:
      const readUpdatedNotifications: NotificationInterface[] = action.payload as NotificationInterface[];
      const notificationStateCopy: { [id:number]: NotificationInterface } = { ...state.notifications };

      for(let i:number = 0; i < readUpdatedNotifications.length; i = i + 1) {
        notificationStateCopy[readUpdatedNotifications[i].id] = new Notification(readUpdatedNotifications[i]);
      }

      return {
        ...state,
        notifications: notificationStateCopy,
      };

    case NotificationActionType.LoadNotificationTemplatesCompleted:
      const templates: NotificationTemplateInterface[] = action.payload as NotificationTemplateInterface[];

      return {
        ...state,
        notificationTemplates: templates ? templates : [],
      };

    case NotificationActionType.SendNotificationsCompleted:
      const numSent: number = action.payload.length;

      return {
        ...state,
        sendResults: numSent,
      };

    case NotificationActionType.CreateNotificationTemplate:
    case NotificationActionType.UpdateNotificationTemplate:
    case NotificationActionType.DeleteNotificationTemplate:
      return {
        ...state,
        selectedTemplate: undefined,
      };

    case NotificationActionType.UpdateNotificationTemplateComplete:
      const newTemplate: NotificationTemplateInterface = action.payload;

      let found: boolean = false;

      const updateTemplateLibrary: NotificationTemplateInterface[] = state.notificationTemplates
        .map((template: NotificationTemplateInterface) => {
          if(template.id === newTemplate.id) {
            found = true;
            return newTemplate;
          }
          return template;
        });

      if(!found) {
        updateTemplateLibrary.push(newTemplate);
      }

      return {
        ...state,
        notificationTemplates: updateTemplateLibrary,
        selectedTemplate: newTemplate,
      };

    case NotificationActionType.DeleteNotificationTemplateComplete:
      const deletedTemplate: NotificationTemplateInterface = action.payload;

      const libraryWithoutTemplate: NotificationTemplateInterface[] = state.notificationTemplates
        .filter((template: NotificationTemplateInterface) => {
          if(template.id !== deletedTemplate.id) {
            return template;
          }
        });

      return {
        ...state,
        notificationTemplates: libraryWithoutTemplate,
        selectedTemplate: deletedTemplate,
      };

    default:
      return state;
  }

}
